import { getHaklaiAcquisitionDisplayDate } from "../preCalc/logic/haklaiPreCalcHelpers";

export const MAX_PRISA_YEARS = 4;

const getPrisaYearDiff = (preCalc) => {
  const soldPropertyDate = preCalc?.soldPropertyDate;
  const purchaseDate = getHaklaiAcquisitionDisplayDate(preCalc);
  if (!soldPropertyDate || !purchaseDate) return null;
  const diff = parseInt(soldPropertyDate.substring(0, 4), 10) - parseInt(purchaseDate.substring(0, 4), 10);
  return diff;
};

export const getHaklaiPrisaMaxYears = (preCalc) => {
  const diff = getPrisaYearDiff(preCalc);
  if (diff === null) return MAX_PRISA_YEARS;
  return Math.max(0, Math.min(MAX_PRISA_YEARS, diff));
};

export const getHaklaiPrisaMinYears = (preCalc) => {
  const diff = getPrisaYearDiff(preCalc);
  if (diff === null) return MAX_PRISA_YEARS;
  return Math.max(0, Math.min(MAX_PRISA_YEARS, diff));
};
